import { useState, useEffect } from "react";
import { Menu, X, HelpCircle } from "lucide-react";
import FAQPopup from "./FAQPopup";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isFAQOpen, setIsFAQOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
  { href: "#about", label: "About" },
  { href: "#portfolio", label: "Portfolio" },
  { href: "#services", label: "Services" },
  { href: "#rentals", label: "Rentals" },
  { href: "#testimonials", label: "Kind Words" },
  { href: "#gift-cards", label: "Gift Cards" },
  { href: "#contact", label: "Contact" },
  { href: "#booking", label: "Book Now" }];


  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      isScrolled ?
      "glass-header border-b border-[#E8E4DD]" :
      "bg-transparent"}`
      }
      data-testid="header">

      <nav className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#"
            className="font-heading text-2xl tracking-tight text-[#2C2A28] hover:text-[#5C5A56] transition-colors"
            data-testid="logo">Brittany Bailey Photography


          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) =>
            <button
              key={link.href}
              onClick={() => scrollToSection(link.href)}
              className={`font-body text-sm tracking-wide transition-colors duration-300 ${
              link.label === "Book Now" ?
              "px-5 py-2 bg-[#2C2A28] text-[#FDFBF9] hover:bg-[#5C5A56]" :
              "text-[#5C5A56] hover:text-[#2C2A28]"}`
              }
              data-testid={`nav-${link.label.toLowerCase().replace(" ", "-")}`}>

                {link.label}
              </button>
            )}
            {/* FAQ Button */}
            <button
              onClick={() => setIsFAQOpen(true)}
              className="flex items-center gap-1 font-body text-sm tracking-wide text-[#5C5A56] hover:text-[#2C2A28] transition-colors duration-300"
              data-testid="nav-faq"
            >
              <HelpCircle size={16} />
              FAQ
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-[#2C2A28]"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle">

            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen &&
        <div
          className="lg:hidden absolute top-20 left-0 right-0 bg-[#FDFBF9] border-b border-[#E8E4DD] py-6 px-6"
          data-testid="mobile-menu">

            <div className="flex flex-col space-y-4">
              {navLinks.map((link) =>
            <button
              key={link.href}
              onClick={() => scrollToSection(link.href)}
              className={`font-body text-left py-2 transition-colors ${
              link.label === "Book Now" ?
              "px-5 py-3 bg-[#2C2A28] text-[#FDFBF9] text-center" :
              "text-[#5C5A56] hover:text-[#2C2A28]"}`
              }
              data-testid={`mobile-nav-${link.label.toLowerCase().replace(" ", "-")}`}>

                  {link.label}
                </button>
            )}
              {/* Mobile FAQ Button */}
              <button
                onClick={() => {
                  setIsFAQOpen(true);
                  setIsMobileMenuOpen(false);
                }}
                className="font-body text-left py-2 text-[#5C5A56] hover:text-[#2C2A28] flex items-center gap-2"
                data-testid="mobile-nav-faq"
              >
                <HelpCircle size={16} />
                FAQ
              </button>
            </div>
          </div>
        }
      </nav>
    </header>
    
    {/* FAQ Popup */}
    <FAQPopup isOpen={isFAQOpen} onClose={() => setIsFAQOpen(false)} />
    </>
  );

};

export default Header;